import type { ChatMessage } from '@/types/chat';
import { getLatestAssistantProcessingSteps } from './getLatestAssistantProcessingSteps';

export type ChatProcessingStatusInput = {
  isLoading: boolean;
  isWaitingForDocumentProcessing?: boolean;
  messages: ChatMessage[];
};

/** The processing state to announce, or an empty string when nothing is in flight. */
export const getChatProcessingStatusMessage = ({
  isLoading,
  isWaitingForDocumentProcessing,
  messages,
}: ChatProcessingStatusInput): string => {
  if (!isLoading) return '';
  if (isWaitingForDocumentProcessing) return 'Waiting for document processing';

  const steps = getLatestAssistantProcessingSteps(messages);
  const currentStep = [...steps].reverse().find((step) => step.status === 'in_progress');

  return currentStep ? currentStep.label : 'Processing your query';
};
